export default __webpack_public_path__ + "static/media/chargeItUp_active.bba1fc5d.svg";